export const controls = {
	methods: {
		vSelectMultiHideClear (readonly: boolean) {
			if (!readonly) {
				return null
			}

			return {
				Deselect: {
					render: (createElement: any) => null
				}
			}
		}
	}
}
